import { 
  Component, Input, AfterViewInit, OnChanges, Output, EventEmitter, 
  ElementRef, ViewChild, SimpleChanges 
} from '@angular/core';

declare const MathJax: {
  typesetPromise: () => Promise<void>;
};

@Component({
  selector: 'app-latex-math',
  template: `<div #mathContainer></div>`,
  styleUrls: ['./latex-math.component.css'],
  standalone: true
})
export class LatexMathComponent implements AfterViewInit, OnChanges {
  @Input() latex: string = '';
  @Output() base64Change = new EventEmitter<string>();
  @ViewChild('mathContainer', { static: false }) mathContainer!: ElementRef;

  ngAfterViewInit(): void {
    this.renderMath();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['latex'] && !changes['latex'].firstChange) {
      this.renderMath();
    }
  }

  private renderMath(): void {
    if (typeof MathJax !== 'undefined' && this.mathContainer) {
      this.mathContainer.nativeElement.innerHTML = this.latex || '';
      MathJax.typesetPromise().then(() => {
        this.emitBase64();
      });
    }
  }

private emitBase64(): void {
  const container = this.mathContainer?.nativeElement as HTMLElement;
  if (!container) {
    console.warn('LatexMathComponent: mathContainer not found');
    return;
  }

  const svg = container.querySelector('svg');
  if (!svg) {
    console.warn('LatexMathComponent: SVG not found after MathJax render');
    this.base64Change.emit('');
    return;
  }

  // ✅ Serialize SVG as string
  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(svg);

  // ✅ Encode to Base64 (UTF-8 safe)
  const base64Svg = btoa(unescape(encodeURIComponent(svgString)));

  // ✅ Emit raw SVG Base64 (iText7 will decode & render it as vector)
  this.base64Change.emit(base64Svg);
}


}
